import React, { useState } from 'react';
import { Link, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/auth.css';

const Login = () => {
  const navigate              = useNavigate();
  const location              = useLocation();
  const { login, isAuthenticated, user } = useAuth();

  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading]   = useState(false);
  const [errors, setErrors]     = useState({});

  // Already logged in — redirect away from login page
  if (isAuthenticated && user) {
    const dest = user.role === 'Super Admin' ? '/admin' : '/dashboard';
    return <Navigate to={dest} replace />;
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: null });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.username) newErrors.username = 'Username is required';
    if (!formData.password) newErrors.password = 'Password is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    const result = await login(formData);
    setLoading(false);

    if (result.success) {
      // Go back to where they came from, or default by role
      const from = location.state?.from?.pathname;
      const dest = from || (result.role === 'Super Admin' ? '/admin' : '/dashboard');
      navigate(dest, { replace: true });
    }
  };

  return (
    <div className="auth-split-container">
      <div className="auth-banner">
        <div className="banner-content">
          <h2>Welcome to Harvyq</h2>
          <p>ERP by Boldcomp Solutions — run your entire business in one platform.</p>
        </div>
      </div>
      <div className="auth-form-side">
        <div className="auth-card">
          <div className="auth-header">
            <div className="auth-logo">🛍️</div>
            <h1>Welcome Back</h1>
            <p>Sign in to your account</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="username">Username or Email</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="Enter your username or email"
                className={errors.username ? 'error' : ''}
                autoComplete="username"
              />
              {errors.username && (
                <span className="error-message">{errors.username}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                className={errors.password ? 'error' : ''}
                autoComplete="current-password"
              />
              {errors.password && (
                <span className="error-message">{errors.password}</span>
              )}
            </div>

            <div className="form-options">
              <label className="checkbox-label">
                <input type="checkbox" name="remember" />
                Remember me
              </label>
              <Link to="/forgot-password" className="forgot-link">
                Forgot Password?
              </Link>
            </div>

            <button
              type="submit"
              className="auth-button"
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="auth-footer">
            <p>
              Don't have an account?{' '}
              <Link to="/register">Register your business</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;